import { useEffect, useState } from "react";

import { Input } from "#components/atoms/Input/Input";

type InputSize = "sm" | "md";

type InputNumberProps = {
  value: number | null;
  onChange: (value: number) => void;
  onClear?: () => void;
  size?: InputSize;
  min?: number;
  disabled?: boolean;
  "aria-label"?: string;
  placeholder?: string;
};

const formatInputValue = (value: number | null) => (value === null ? "" : String(value));

const InputNumber = ({
  value,
  onChange,
  onClear,
  size = "md",
  min,
  disabled,
  placeholder,
  "aria-label": ariaLabel,
}: InputNumberProps) => {
  const [inputValue, setInputValue] = useState(() => formatInputValue(value));

  useEffect(() => {
    setInputValue(formatInputValue(value));
  }, [value]);

  const handleBlur = () => {
    const trimmed = inputValue.trim();
    if (trimmed === "") {
      if (value !== null && onClear) {
        onClear();
        setInputValue("");
        return;
      }
      setInputValue(formatInputValue(value));
      return;
    }

    const parsed = parseInt(trimmed, 10);
    if (!isNaN(parsed) && (min === undefined || parsed >= min) && parsed !== value) {
      onChange(parsed);
      return;
    }
    setInputValue(formatInputValue(value));
  };

  return (
    <Input
      type="number"
      value={inputValue}
      onChange={setInputValue}
      onBlur={handleBlur}
      size={size}
      min={min}
      disabled={disabled}
      aria-label={ariaLabel}
      placeholder={placeholder}
    />
  );
};

export { InputNumber };
